/**
 * Article-specific styles and components.
 */

import 'htmx.org';
import '@/scss/parts/entry-header.scss';
import '@/scss/parts/social-share.scss';
import '@/scss/parts/entry-info.scss';

window.htmx = require('htmx.org');

window.htmx.config.historyEnabled = false;
window.htmx.config.selfRequestsOnly = true;

if (module.hot) {
  module.hot.accept();
}
